/** Full landing SEO — globalCategories, brands */
export const FULL_LANDING_SEO_FIELDS = [
  'schemaVersion',
  'title',
  'metaDescription',
  'ogTitle',
  'ogDescription',
  'ogImage',
  'h1',
  'introText',
  'bottomText',
  'reviewStatus',
  'indexationMode',
  'updated',
]

/** Compact product SEO — products, outletProducts (future) */
export const COMPACT_PRODUCT_SEO_FIELDS = [
  'schemaVersion',
  'title',
  'metaDescription',
  'ogTitle',
  'ogDescription',
  'ogImage',
  'reviewStatus',
  'indexationMode',
  'updated',
]

export const SEO_TEXT_FIELDS = [
  'title',
  'metaDescription',
  'ogTitle',
  'ogDescription',
  'h1',
  'introText',
  'bottomText',
]
